import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import topics from "@/data/topics.json";
import { Eyebrow, MaskLines } from "@/components/site/Reveal";
import { Connect } from "@/components/site/Connect";
import { Seo } from "@/components/site/Seo";

const Card = ({ t, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
  >
    <Link data-testid={`topic-card-${t.slug}`} to={`/${t.slug}`} className="group block relative rounded-3xl overflow-hidden border border-white/10 bg-panel aspect-[4/3]">
      {t.cover && <img src={t.cover} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover brightness-[0.55] group-hover:brightness-75 group-hover:scale-105 transition-[transform,filter] duration-700" />}
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
      <span className="absolute top-4 left-4 font-mono text-[12px] text-lime bg-ink/70 backdrop-blur rounded-full px-3 py-1">{String(i + 1).padStart(2, "0")}</span>
      <h3 className="absolute bottom-5 left-5 right-5 font-display font-bold uppercase text-2xl sm:text-3xl leading-tight text-white group-hover:text-lime transition-colors duration-300">{t.title}</h3>
    </Link>
  </motion.div>
);

export default function TopicsIndex() {
  return (
    <main data-testid="topics-index-page">
      <Seo
        title="Science Topics to Explore | The Desi Science Page"
        description={`Browse ${topics.length} topics: critical thinking, cognitive biases, logical fallacies, evidence, vaccines, the brain, philosophy, sentientism and more.`}
        path="/topics"
      />
      <section className="px-5 sm:px-10 lg:px-16 pt-36 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 grid-lines opacity-40" />
        <Eyebrow className="relative mb-6">// {topics.length} topics</Eyebrow>
        <h1 className="relative font-display font-bold uppercase leading-[0.85] text-6xl sm:text-8xl lg:text-[9rem]">
          <MaskLines onLoad lines={["Topics", <span className="outline-text">to explore</span>]} />
        </h1>
      </section>
      <section className="px-5 sm:px-10 lg:px-16 pb-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {topics.map((t, i) => <Card key={t.slug} t={t} i={i} />)}
      </section>
      <Connect />
    </main>
  );
}
